import { BrowserRouter, Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useMemo } from "react";
import { HelmetProvider } from "react-helmet-async";
import SEO from "./Components/SEO";
import NotFound from "./Components/NotFound";
import { getSeoForPath } from "./seo/seoConfig";
import ScrollToTop from "./Components/scrollup";
import FloatingActions from "./Components/FloatingActions";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import Contact from "./Pages/Contacts";
/*---------------------------ElementsGroup---------------------------*/
import ElementsGroup from "./Pages/ElementsGroup";
import Histoire from "./Pages/ElementsGroup/Histoire";
import Createurs from "./Pages/ElementsGroup/Createurs";
import Atelier from "./Pages/ElementsGroup/Atelier";
import Partenaires from "./Pages/ElementsGroup/Partenaires";
/*---------------------------Collections---------------------------*/
import Collections from "./Pages/Collections";
import Cuisines from "./Pages/Collections/Cuisines";
import CuisinesProject from "./Pages/Collections/Cuisines/CuisinesProject";
import Dressings from "./Pages/Collections/Dressings";
import DressingsProject from "./Pages/Collections/Dressings/DressingsProject";
import Amenagement from "./Pages/Collections/Amenagement";
import Accessoires from "./Pages/Collections/Accessoires";
import Textures from "./Pages/Collections/Textures";
/*---------------------------Sav---------------------------*/
import Sav from "./Pages/Sav";
import Kit from "./Pages/Sav/Kit";
import Garantie from "./Pages/Sav/Garantie";
import Service from "./Pages/Sav/Service";
/*---------------------------Export---------------------------*/
import Export from "./Pages/Export";
import Projets from "./Pages/Export/Projets";
import CuisinesIntProject from "./Pages/Export/Projets/CuisinesIntProject";
import Temoignages from "./Pages/Export/Temoignages";
import Carte from "./Pages/Export/Carte";
/*------------------------------------------------------*/
import logo from "./images/logo.png";
import "./transition.css";
import ReactGA from "react-ga4";
import { useSmoothScroll } from "./Hooks/useSmoothScroll";
const track_id="G-X31LX4G7K7";
// true pendant le pré-rendu (scripts/prerender.mjs) : pas d'analytics
const IS_PRERENDER = typeof window !== "undefined" && window.__PRERENDER__ === true;
function RouteSEO() {
  const { pathname } = useLocation();
  const seo = useMemo(() => getSeoForPath(pathname), [pathname]);
  return <SEO {...seo} />;
}

function AppContent() {

const [transition,setTransition] = useState("")
const navigate = useNavigate()
const location = useLocation()
 useSmoothScroll();
const handleNavigation = (path)=>{

setTransition("active")

setTimeout(()=>{
navigate(path)
setTransition("active white")
},700)

setTimeout(()=>{
setTransition("")
},1600)

}

return (

<div className="App">

<div className={`page-transition ${transition}`}>
<img src={logo} className="transition-logo" alt="logo"/>
</div>

<Header navigateWithTransition={handleNavigation}/>
<ScrollToTop/>
<div className="page-content" key={location.pathname}>
<Routes location={location}>
<Route path="/" element={<Home/>}/>
<Route path="/contact" element={<Contact navigateWithTransition={handleNavigation} />} />
{/*---------------------------ElementsGroup---------------------------*/}
<Route
path="/elements"
element={<ElementsGroup navigateWithTransition={handleNavigation} />}
>
<Route index element={<Navigate to="/elements/histoire" replace />} />
<Route path="histoire" element={<Histoire  navigateWithTransition={handleNavigation}  />} />
<Route path="createurs" element={<Createurs  navigateWithTransition={handleNavigation}  />} />
<Route path="atelier" element={<Atelier  navigateWithTransition={handleNavigation}  />} />
<Route path="partenaires" element={<Partenaires  navigateWithTransition={handleNavigation}  />} />
</Route>
{/*---------------------------Collections---------------------------*/}
<Route
path="/collections"
element={<Collections navigateWithTransition={handleNavigation} />}
>
<Route index element={<Navigate to="/collections/cuisines" replace />} />
<Route path="cuisines" element={<Cuisines  navigateWithTransition={handleNavigation}  />} />
<Route path="cuisines/:name" element={<CuisinesProject  navigateWithTransition={handleNavigation}  />} />
<Route path="dressings" element={<Dressings  navigateWithTransition={handleNavigation}  />} />
<Route path="dressings/:name" element={<DressingsProject  navigateWithTransition={handleNavigation}  />} />
<Route path="amenagement" element={<Amenagement  navigateWithTransition={handleNavigation}  />} />
<Route path="accessoires" element={<Accessoires  navigateWithTransition={handleNavigation}  />} />
<Route path="textures" element={<Textures  navigateWithTransition={handleNavigation}  />} />
</Route>
{/*---------------------------Sav---------------------------*/}
<Route
path="/sav"
element={<Sav navigateWithTransition={handleNavigation} />}
>
<Route index element={<Navigate to="/sav/garantie" replace />} />
<Route path="kit-nettoyage" element={<Kit navigateWithTransition={handleNavigation}  />} />
<Route path="garantie" element={<Garantie  navigateWithTransition={handleNavigation}  />} />
<Route path="service-apres-vente" element={<Service  navigateWithTransition={handleNavigation}  />} />

</Route>
{/*---------------------------Export---------------------------*/}
<Route
path="/export"
element={<Export navigateWithTransition={handleNavigation} />}
>
<Route index element={<Navigate to="/export/projets-international" replace />} />
<Route path="projets-international" element={<Projets  navigateWithTransition={handleNavigation}  />} />
<Route path="projets-international/:name" element={<CuisinesIntProject  navigateWithTransition={handleNavigation}  />} />
<Route path="temoignages-clients" element={<Temoignages  navigateWithTransition={handleNavigation}  />} />
<Route path="carte" element={<Carte  navigateWithTransition={handleNavigation}  />} />
</Route>
{/*---------------------------404---------------------------*/}
<Route path="*" element={<NotFound />} />
</Routes>
</div>
<FloatingActions />
<Footer/>
</div>

)

}

export default function App(){
useEffect(() => {
  if (IS_PRERENDER) return;
  // send_page_view:false → les pages vues sont envoyées une seule fois par RouteTracker
  ReactGA.initialize(track_id, { gtagOptions: { send_page_view: false } });
}, []);
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (IS_PRERENDER) return;
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      title: document.title,
    });

    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location]);

  return null;
}
return(

  <HelmetProvider>
    <BrowserRouter>
      <RouteSEO />
      <RouteTracker />
      <AppContent />
    </BrowserRouter>
  </HelmetProvider>
);



}